export const getDialogName = (chatCaption, clientProfile, receiver, t) => {
  return chatCaption ?? clientProfile?.name ?? t('dlg:guestNumber', { number: receiver?.slice(0, 5) })
}

export const fixedEncode = (str) => {
  return str?.replaceAll('&lt;', '<').replaceAll('&gt;', '>')
}
